﻿<template>
  <!-- â”€â”€ Icon mode â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ -->
  <template v-if="mode === 'icon'">
    <div
      class="device-icon-pin"
      :class="[sizeClass, isUnlocked ? 'device-active--strike-lock' : '']"
      :style="{ '--pin-active-color': 'var(--device-color-strike-lock)' }"
      :title="device.deviceName">
      <!-- The drawn strike inside the status ring (P14) â€” the entry lock's own
           semantic, inverted against the padlock's: OPEN is the lit state
           (`unlock` + a full ring), held shut keeps the track. The same fold
           the sheet's hero reads. -->
      <ControlStatusRing :value="isUnlocked ? 100 : 0">
        <div class="strike-pin-art">
          <LockAnimation :kind="lockKind" :locked="!isUnlocked" />
        </div>
      </ControlStatusRing>
      <div v-if="isUnlocked" class="device-icon-pin__glow"></div>
    </div>
  </template>

  <!-- â”€â”€ Card mode â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ -->
  <template v-else-if="mode === 'card'">
    <!-- Card face: the strike lock's picture, its name and its state; the
         largest size carries the open verb. -->
    <DeviceCardShell
      :size="cardSize ?? 'min'"
      :name="device.deviceName"
      :title="device.deviceName"
      :active="isUnlocked"
      :accent="cardAccent"
      class="strike-card-face"
      :class="{ 'strike-card-face--unlocked': isUnlocked }"
      @click="handleToggle"
      @contextmenu.prevent="emit('open-control-modal')">
      <template #media>
        <!-- Raw <img> rather than DeviceThumbnail: that component is a fixed 2rem
             circle for the compact tile, which left the card's photo tiny. -->
        <img v-if="thumbUrl" :src="thumbUrl" alt="" class="strike-card-face__img" draggable="false" />
        <LockAnimation v-else class="strike-card-face__figure" :kind="lockKind" :locked="!isUnlocked" />
      </template>

      <template v-if="cardSize !== 'min'" #value>
        <span class="strike-card-face__value">{{
          isUnlocked ? tt('Open', 'Odprto') : tt('Locked', 'Zaklenjeno')
        }}</span>
      </template>

      <template v-if="cardSize === 'max'" #control>
        <button
          type="button"
          class="strike-card-face__power"
          :class="{ 'strike-card-face__power--on': isUnlocked }"
          :disabled="controlling"
          @click.stop="isUnlocked ? handleToggle() : handleUnlock()">
          <span class="material-symbols-outlined">lock_open</span>
          {{ isUnlocked ? tt('Lock', 'Zakleni') : tt('Open', 'Odpri') }}
        </button>
      </template>
    </DeviceCardShell>
  </template>

  <!-- â”€â”€ Grid mode â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ -->
  <template v-else-if="mode === 'grid'">
    <DeviceGridCell
      :icon="device.icon || (isUnlocked ? 'lock_open' : 'lock')"
      :name="device.deviceName"
      :is-on="isUnlocked"
      active-color="orange-400"
      @toggle="handleToggle"
      @long-press="emit('open-control-modal')" />
  </template>

  <!-- â”€â”€ Control mode â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ -->
  <!-- The chrome owns the head (card t_488df70b); this body is the strike's own
       circle + the one Unlock action (the old body's `setProperty('unlock',
       true)` write, kept verbatim â€” the widget's own strike semantics). -->
  <template v-else-if="mode === 'control'">
    <div class="strike-sheet">
      <div class="strike-hero">
        <button
          type="button"
          class="strike-circle"
          :class="{ 'strike-circle--open': isUnlocked, 'strike-circle--busy': controlling }"
          :disabled="controlling"
          @click="handleUnlock">
          <div class="strike-circle__art">
            <LockAnimation :kind="lockKind" :locked="!isUnlocked" />
          </div>
        </button>
        <div class="strike-state" :class="{ 'strike-state--open': isUnlocked }">
          {{ isUnlocked ? tt('Unlocked', 'Odklenjeno') : tt('Locked', 'Zaklenjeno') }}
        </div>
        <div class="strike-caption">
          {{
            isUnlocked
              ? tt('Strike open â€” will auto-lock', 'Zapah odprt â€” samodejno zaklepanje')
              : tt('Tap to unlock', 'Dotaknite se za odklep')
          }}
        </div>
      </div>

      <div class="strike-actions">
        <ControlChip :disabled="controlling" @click="handleUnlock">
          <ControlIcon name="unlock" size="1.1em" />
          {{ tt('Unlock', 'Odkleni') }}
        </ControlChip>
      </div>

      <p v-if="lastUpdated" class="strike-updated">
        {{ tt('Last updated:', 'Zadnja posodobitev:') }} {{ lastUpdated }}
      </p>

      <!-- Activity timeline -->
      <SetpointTimeline
        :device-values="device.deviceValues ?? []"
        :device-id="device.id"
        accent-color="rgb(249, 115, 22)" />
    </div>
  </template>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { formatTime } from '../../utils/formatDate';
import ControlIcon from '../device-icons/ControlIcon.vue';
import ControlChip from '../device-sheet/ControlChip.vue';
import ControlStatusRing from '../device-sheet/ControlStatusRing.vue';
import DeviceCardShell from './DeviceCardShell.vue';
import { useDeviceValues } from '../../composables/useDeviceValues';
import { useDeviceControl } from '../../composables/useDeviceControl';
import DeviceGridCell from '../panel/DeviceGridCell.vue';
import SetpointTimeline from './SetpointTimeline.vue';

import { tt } from '../../utils/consoleText';
import type { Device } from '@/types';
import { readField, type LockKind } from './deviceWidgetTypes';
import LockAnimation from './lock/LockAnimation.vue';
import { getDefaultThumbnailUrl } from '../../composables/useDeviceThumbnail';

interface Props {
  device: Device;
  mode?: 'icon' | 'card' | 'control' | 'grid';
  size?: 'sm' | 'md' | 'lg';
  fluid?: boolean;
  displayMode?: 'full' | 'room';
  /** Set by the pages that grid cards (`DeviceButton`) â€” `undefined` keeps the
   *  compact button row other surfaces have always drawn. */
  cardSize?: 'min' | 'mid' | 'max';
}

const props = withDefaults(defineProps<Props>(), { mode: 'card', size: 'md', cardSize: undefined });

const emit = defineEmits<{
  toggle: [];
  'open-control-modal': [];
  'view-stream': [];
  'view-details': [];
  'value-update': [valueId: string, newValue: unknown];
}>();

// â”€â”€ State â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const { currentValues, initializeValues } = useDeviceValues(props.device.id);
const { controlling, setProperty } = useDeviceControl();

if (props.device.deviceValues?.length) initializeValues(props.device.deviceValues);
watch(
  () => props.device.deviceValues,
  (v) => {
    if (v?.length) initializeValues(v);
  },
  { deep: true },
);

// true = unlocked (unlock value is true when the strike is open)
const isUnlocked = computed(() => {
  const unlockDp = props.device.deviceValues?.find((dp) => readField(dp, 'property_key') === 'unlock');
  if (unlockDp !== undefined) return unlockDp.currentValue === true;
  const key = ['unlock', 'power', 'on_off', 'state'].find((k) => k in currentValues.value);
  if (key) {
    const v = currentValues.value[key];
    return v === true || v === 1 || v === 'on';
  }
  const dv = props.device.deviceValues?.find((v) => ['unlock', 'power', 'on_off', 'state'].includes(v.valueKey));
  return dv?.currentValue === true || dv?.currentValue === 1 || dv?.currentValue === 'on';
});

const lastUpdated = computed(() => (Object.keys(currentValues.value).length > 0 ? formatTime(new Date()) : ''));

/**
 * The same rule the lock card follows (owner, 25.10.2026: *"similar bg for
 * locks.. if locked no effect.. if unlocked then effect"*): a released strike
 * is the state worth seeing, so only then does the card take a tone.
 */
const cardAccent = computed<string | null>(() => (isUnlocked.value ? 'var(--strike-card-tone)' : null));

/** The card's picture, resolved through the S3-key blob cache. */
const thumbUrl = computed(() => getDefaultThumbnailUrl(props.device));

/**
 * The electric opening's own picture: the strike, always. The class offers only
 * `auto` and `strike`, and this widget exists because the device *is* the
 * electric release â€” there is nothing to resolve.
 */
const lockKind: LockKind = 'strike';

async function handleUnlock() {
  // Always send true to unlock; auto-lock behavior handles re-locking
  await setProperty(props.device, 'unlock', true);
}

function handleToggle() {
  handleUnlock();
}
const sizeClass = computed(() => (props.fluid ? 'device-icon-pin--fluid' : `device-icon-pin--${props.size ?? 'md'}`));
</script>

<style scoped>
.active .device-icon span,
.active .device-name,
.active .device-current-value {
  color: var(--device-color-strike-lock) !important;
}
.active {
  border-color: var(--device-color-strike-lock) !important;
  background-color: transparent !important;
}

/* â”€â”€ Control mode: the sheet body â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.strike-sheet {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(1rem * var(--ui-space-factor));
}

.strike-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding-top: calc(0.25rem * var(--ui-space-factor));
}

/* The strike's own circle â€” the amber strike-lock accent while the strike is
   open (its "live" state), calm otherwise. */
.strike-circle {
  width: 6rem;
  height: 6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--glass-edge);
  border-radius: 50%;
  background: rgba(148, 163, 184, 0.1);
  color: rgb(var(--gray-500));
  cursor: pointer;
  transition:
    color 0.2s,
    border-color 0.2s,
    background 0.2s,
    box-shadow 0.2s,
    transform 0.15s;
}

.dark .strike-circle {
  background: rgba(255, 255, 255, 0.04);
  color: rgb(var(--gray-400));
}

.strike-circle:hover:not(:disabled) {
  transform: scale(1.03);
}

.strike-circle:disabled {
  cursor: default;
  opacity: 0.65;
}

.strike-circle--open {
  color: var(--device-color-strike-lock);
  border-color: color-mix(in srgb, var(--device-color-strike-lock) 55%, transparent);
  background: color-mix(in srgb, var(--device-color-strike-lock) 16%, transparent);
  box-shadow: 0 0 18px color-mix(in srgb, var(--device-color-strike-lock) 18%, transparent);
}

.strike-circle--busy {
  animation: strike-busy 1s ease-in-out infinite;
}

@keyframes strike-busy {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

.strike-state {
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.2;
  color: rgb(var(--gray-600));
}

.dark .strike-state {
  color: rgb(var(--gray-200));
}

.strike-state--open {
  color: var(--device-color-strike-lock);
}

.strike-caption {
  font-size: 0.75rem;
  color: rgb(var(--gray-500));
}

.dark .strike-caption {
  color: rgb(var(--gray-400));
}

.strike-actions {
  display: flex;
  justify-content: center;
}

.strike-updated {
  margin: 0;
  align-self: center;
  font-size: 0.6875rem;
  color: rgb(var(--gray-500));
}

.dark .strike-updated {
  color: rgb(var(--gray-400));
}

@media (prefers-reduced-motion: reduce) {
  .strike-circle--busy {
    animation: none !important;
  }
}

/* â”€â”€ Card face â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.strike-card-face__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.strike-card-face__figure {
  width: 66%;
  height: 66%;
}

/* The strike inside the pin, sized off the ring's clear circle. */
.strike-pin-art {
  width: 64%;
  height: 64%;
}

/* The sheet's 6rem circle holds the drawing, not a glyph. */
.strike-circle__art {
  width: 3.6rem;
  height: 3.6rem;
}

.strike-card-face__value {
  flex: none;
  text-align: center;
  font-size: var(--card-value, 0.85rem);
  font-weight: 600;
  color: #64748b;
}

.dark .strike-card-face__value {
  color: #94a3b8;
}

/* â”€â”€ The released card â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   Only a released strike calls attention; locked, the card keeps the neutral
   surface. The released card borrows the lock and sensor language: a nearly
   transparent tint plus a glowing edge that flashes, in the device's own
   orange. */
.strike-card-face {
  --strike-card-tone: rgb(249, 115, 22);
  --strike-card-tone-low: 0.02;
  --strike-card-tone-high: 0.28;
  --strike-card-halo-low: 0.15;
  --strike-card-breath: 1.7s;
  position: relative;
  isolation: isolate;
}

.dark .strike-card-face {
  --strike-card-tone: rgb(251, 146, 60);
  --strike-card-tone-low: 0.03;
  --strike-card-tone-high: 0.3;
}

/* The shell's own soft edge and faint wash are exactly this card's surface; only
   its static glow is silenced, because the flashing halo below is the signal. */
.strike-card-face.device-card--accent.device-card--on {
  box-shadow: none;
}

.strike-card-face::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1; /* above the card's own fill, below its content */
  border-radius: inherit;
  background: var(--strike-card-tone);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.strike-card-face::after {
  content: '';
  position: absolute;
  inset: -1px;
  border-radius: inherit;
  pointer-events: none;
  box-shadow:
    0 0 0 1px color-mix(in srgb, var(--strike-card-tone) 60%, transparent),
    0 0 0.75rem color-mix(in srgb, var(--strike-card-tone) 70%, transparent),
    0 0 1.7rem color-mix(in srgb, var(--strike-card-tone) 42%, transparent);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.strike-card-face--unlocked::before {
  animation: strike-card-warn-flash var(--strike-card-breath) ease-in-out infinite;
}

.strike-card-face--unlocked::after {
  animation: strike-card-halo-flash var(--strike-card-breath) ease-in-out infinite;
}

/* The flash: a fast rise, a slower fall (the on-beat lands at 35 % of the
   cycle), so the card reads as pulsing a warning rather than breathing. */
@keyframes strike-card-warn-flash {
  0%,
  100% {
    opacity: var(--strike-card-tone-low);
  }
  35% {
    opacity: var(--strike-card-tone-high);
  }
}

/* The halo flashes in step and never goes fully dark, so the edge stays
   readable while the tint swings. */
@keyframes strike-card-halo-flash {
  0%,
  100% {
    opacity: var(--strike-card-halo-low);
  }
  35% {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .strike-card-face--unlocked::before {
    animation: none;
    opacity: calc((var(--strike-card-tone-low) + var(--strike-card-tone-high)) / 2);
  }

  .strike-card-face--unlocked::after {
    animation: none;
    opacity: 0.85;
  }
}

.strike-card-face__power {
  display: inline-flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  border-radius: 0.5rem;
  background: rgba(148, 163, 184, 0.16);
  padding: 0.3rem 0.4rem;
  font-size: 0.72rem;
  font-weight: 600;
  color: #475569;
}

.strike-card-face__power--on {
  background: rgba(249, 115, 22, 0.2);
  color: #c2410c;
}

.strike-card-face__power .material-symbols-outlined {
  font-size: 1rem;
}

.dark .strike-card-face__power {
  background: rgba(255, 255, 255, 0.08);
  color: #cbd5e1;
}

.dark .strike-card-face__power--on {
  background: rgba(249, 115, 22, 0.2);
  color: #fdba74;
}
</style>
